import { OrbitApi } from "api"

class AuthAPI {
  static getOtpByEmail(email, captchaToken) {
    // if(isDemo) --> get from indexedDB
    return OrbitApi.httpPost(`/auth/otp`, {}, { email, captchaToken })
  }

  static logUserIn(email, otp) {
    return OrbitApi.httpPost(`/auth/login`, {}, { email, otp })
  }

  static logUserOut() {
    return OrbitApi.httpPost(`/auth/logout`)
  }
}

export default AuthAPI
